import React from 'react';
import { useLocation } from './Router';

export function navigate(href, replace) {
    if (replace) {
        window.history.replaceState({}, '', href);
    } else {
        window.history.pushState({}, '', href);
    }
    window.dispatchEvent(new CustomEvent('xs_navigation', null));
}

export default function Link(props) {
    const location = useLocation();

    const newProps = Object.assign({}, props);
    let replace = false;
    
    if (props.useDiv) {
        delete newProps.useDiv;
        delete newProps.href;
    }
    if (newProps.replace) {
        replace = true;
        delete newProps.replace;
    }
    if (typeof props.className === 'function') {
        const href = props.href;
        let active = false;
        if (props.exact) {
            delete newProps.exact;
            active = location === href;
        } else if (href?.length > 0) {
            active = location.startsWith(href);
        }
        newProps.className = newProps.className(active);
    }

    function handleClick(e) {
        e.preventDefault();
        e.stopPropagation();
        if (props.onClick) {
            props.onClick(e);
        }
        navigate(props.href, replace);
    }

    if (props.useDiv) {
        return (
            <div {...newProps} onClick={handleClick} />
        );
    }

    return (
        <a {...newProps} onClick={handleClick} />
    );
}
